// MIT License - Copyright (c) 2026 Doug McNall

import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import Button from './Button';
import './ShipNamingModal.css';
import STORAGE_KEYS from '../utils/system/STORAGE_KEYS';

/**
 * Ship Naming Modal
 * 
 * Allows players to name their ship
 */
const ShipNamingModal = ({ isOpen, onClose }) => {
  const [shipName, setShipName] = useState('');
  const [currentName, setCurrentName] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEYS.SHIP_NAME) || 'USS Enterprise';
    setCurrentName(saved);
    setShipName(saved);
  }, [isOpen]);

  const handleSave = () => {
    if (shipName.trim()) {
      localStorage.setItem(STORAGE_KEYS.SHIP_NAME, shipName.trim());
      setCurrentName(shipName.trim());
      onClose();
    }
  };

  const randomNames = [
    'USS Enterprise', 'Millennium Falcon', 'Serenity', 'Rocinante',
    'Heart of Gold', 'Normandy', 'Galactica', 'Discovery',
    'Voyager', 'Defiant', 'Bebop', 'Nostromo',
    'Event Horizon', 'Prometheus', 'Icarus', 'Phoenix'
  ];

  const handleRandom = () => {
    const random = randomNames[Math.floor(Math.random() * randomNames.length)];
    setShipName(random);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="🚀 SHIP NAMING"
      size="small"
    >
      <div className="ship-naming-content">
        <div className="ship-naming-current">
          <div className="ship-naming-label">Current Ship Name:</div>
          <div className="ship-naming-current-name">{currentName}</div>
        </div>

        <div className="ship-naming-input-group">
          <label className="ship-naming-label">New Ship Name:</label>
          <input
            type="text"
            className="ship-naming-input"
            value={shipName}
            onChange={(e) => setShipName(e.target.value)}
            placeholder="Enter ship name..."
            maxLength={30}
            autoFocus
          />
          <div className="ship-naming-char-count">
            {shipName.length}/30 characters
          </div>
        </div>

        <div className="ship-naming-suggestions">
          <div className="ship-naming-label">Need inspiration?</div>
          <Button
            onClick={handleRandom}
            variant="secondary"
            size="small"
          >
            🎲 Random Name
          </Button>
        </div>

        <div className="ship-naming-buttons">
          <Button onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button 
            onClick={handleSave} 
            variant="primary"
            disabled={!shipName.trim()}
          >
            Save Name
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ShipNamingModal;
